import { AlertTriangle, Home } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';

export function SuperadminBanner() {
  const { tenant, viewingAsSuperadmin, returnHome } = useAuth();

  if (!viewingAsSuperadmin) return null;

  const handleReturnHome = async () => {
    try {
      await returnHome();
      window.location.reload();
    } catch (error) {
      console.error('Failed to return home:', error);
    }
  };

  return (
    <div 
      className="bg-warning text-warning-foreground px-4 py-2 flex items-center justify-between text-sm"
      data-testid="superadmin-banner"
    >
      <div className="flex items-center gap-2">
        <AlertTriangle className="h-4 w-4" />
        <span>
          You are viewing <strong>{tenant?.display_name}</strong> as a Superadmin. 
          All changes will affect this tenant&apos;s data.
        </span>
      </div>
      <Button 
        size="sm" 
        variant="secondary"
        onClick={handleReturnHome}
        className="h-7 px-3 bg-black/20 hover:bg-black/30 text-warning-foreground border-0"
        data-testid="banner-return-home-btn"
      >
        <Home className="h-3 w-3 mr-1" />
        Return Home
      </Button>
    </div>
  );
}
